import { generateWorkflowConfig } from '@carrier-ecat/ngecat-commonworkflowui';
import packageJson from '../package.json';
import { RULES, RULESETS } from './constants/rules';
import step1 from "../src/steps/step1";
import step2 from './steps/step2';
// http://localhost:3000/NGECAT-Global-CDU-UI/New%20selection?TemplateId=ae495a99-9fb9-41a1-82cd-0ced358cc3ba
const config = generateWorkflowConfig({
    platformConfiguration: {
        guid: "ae495a99-9fb9-41a1-82cd-0ced358cc3ba",
        name: 'Coolant Distribution Unit',
        urlPath: '/ngecat-emea-globalcdu-ui',
        region: "NAO",
        translationId: "180"
    },
    global: {
        assetStoragePath: 'CDUGlobal',
        currentVersion: packageJson.version,
        permissions: [],
        priceConfiguration: {
            currency: 'USD',
            showPrice: true,
            priceDecimalDigits: 2,
            useTrailingZeros: true
        }
    },
    rules: {
        productLine: 'Coolant Distribution Unit',
        rules: RULES,
        rulesets: RULESETS,
        selectionRuleset: 'SEL_CDU',
        validityPropName: 'Tag_bValid',
        rulesetPropName: 'Tag_sConfigRuleset',
        candidateRulesDefinition: [{ propertyName: 'BU_sModel' }, { propertyName: 'BU_sUnitSize' }],
        partNumber: 'PN_sModel'
    },
    strategies: {
        cart: {
            enableDraggableItems: true,
        },
        defaulting: {
            getInitialStateAtStepChange: false,
        },
        cacheConfiguration: {
            enable: false,
        }
    },
    tags: {
        tagModel: 'BU_sModel',
        tagSize: 'BU_nUnitSize',
        tagQty: 'Tag_nQty',
    },
    capabilities: {
        releaseNote: true,
        debug: false,
        searchableConfiguration: false,
        showPrice: true,
        cart: true,
    },
    steps: [
        step1,
        step2,
        {
            stepIndex: 2,
            type: 'candidate',
            name: 'Candidate selection',
            tags: [],
            mapping: {
                path: {
                    datasource: 'water-source-heat-pumps-nao/CW/mapping/DataSource_Mapping.json',
                    metadata: 'water-source-heat-pumps-nao/CW/mapping/MetaData_Mapping.json',
                },
                selectionCalcProps: {
                    gridProperties: {
                        singleSelectGrid: true,
                    },
                    enableActionButtons: false,
                    additionalAssigmentsToAppend: {
                        Selection: {
                            Calc_sCalculationEngine: {
                                Value: 'LegacyWSHP60',
                            },
                            Calc_sMappingFileName: {
                                Value: 'Mapping_WSHP_NAO.xml',
                            },
                            Calc_bSelection: {
                                Value: 'TRUE',
                            },
                            Calc_XMLFormat: {
                                Value: '4',
                            },
                        },
                    },
                    propForGridMessageOnRowSelection: [],
                    propNameForModelNumber: 'BU_sModel',
                },
            },
        },
        {
            stepIndex: 3,
            type: 'configuration',
            name: 'Configure unit',
            tags: [],
            sections: [
                {
                    label: 'Options',
                    id: 'options',
                    allCategories: true,
                    rulesCategoryName: 'Opt_sCategory',
                    tags: ['UI_CONFIG_UNIT_OPT'],
                },
            ]
        },
        {
            stepIndex: 4,
            type: 'report',
            name: 'Generate reports',
            tags: ['UI_CONFIG_RPT'],
            reports: [
                {
                    id: 'performance-report',
                    tags: [],
                    label: 'Performance Report',
                    rules: [
                        { name: "Report_bPerformance" }
                    ]
                }
            ],
            getReportMapping: (_) => {
                return {
                    FullDataSourcesMappingFileName: "coolantcoolant-distribution-unit-global/mappings/65LL/GlobalCoolantDistributionUnit_DataSources_Mapping.json",
                    FullMetaDataMappingFileName: "coolantcoolant-distribution-unit-global/mappings/65LL/GlobalCoolantDistributionUnit_MetaData_Mapping.json",
                    path: {
                        datasource: '',
                        metadata: ''
                    }
                };
            }
        }
    ]
});
export default config;
